/* FreeKick Sports - patches como linha de cobranca no carrinho.
   Porte do script inline da MD. Config vem de window.mdPatchesCfg = { variante, handle, checar, base, variantes }
   (escrito no layout/theme.liquid a partir do setting md_patch_produto).
   Fluxo: ao submeter o form da camisa com patch marcado, manda /cart/add com items:[extras..., camisa];
   todas as linhas levam a propriedade _md_tie (amarra) e a camisa guarda _md_patches = "P44@Right Sleeve,...".
   22/10/2026 (pedido do dono: o fornecedor precisa VER o patch e saber em qual camisa vai):
   - o produto `patch` tem uma variante por codigo (sku = codigo, foto do patch como imagem da variante); `variantes`
     mapeia codigo -> { id, nome }. Cada codigo vira uma linha de cobranca propria (com a foto), em vez de uma linha
     generica com quantidade = n de patches. Codigo sem variante cai na generica (`variante`).
   - a camisa recebe as propriedades visiveis "Patches" = "Nome (Local), ..." e "Patch photo" = URLs das fotos;
     a linha do patch recebe "Patch" = "Nome (Local)" e "Shirt" = titulo da camisa + variante.
   A reconciliacao mantem, por amarra e por variante, a quantidade do extra = (n de patches daquele codigo x quantidade da camisa). */
(function () {
  'use strict';
  if (window.__mdPatchesCarrinho) return;
  window.__mdPatchesCarrinho = true;
  var CFG = window.mdPatchesCfg || {};
  var VARIANTE = parseInt(CFG.variante, 10) || 0;
  var HANDLE = CFG.handle || 'patch';
  var BASE = String(CFG.base || '').replace(/\/+$/, '');
  var MAPA = CFG.variantes || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var URL_ADD = ROOT + 'cart/add';
  var URL_UPDATE = ROOT + 'cart/update';
  var URL_CART = ROOT + 'cart';
  var CHECAR_NA_CARGA = !!CFG.checar;
  var LOCAIS = ['Chest', 'Sleeve', 'Right Sleeve', 'Left Sleeve', 'Legacy', 'Sponsor', 'Match Details', 'Back Sponsor'];
  var ocupado = false, pendente = false, tentativasAdd = {}, MAX_ADD = 3;

  function varDe(codigo) { var m = MAPA[codigo]; var id = m && parseInt(m.id, 10); return id || VARIANTE; }
  function nomeDe(codigo) { var m = MAPA[codigo]; if (!m || !m.nome) return codigo; return String(m.nome).replace(/\s*\([^()]*\)\s*$/, ''); }
  function rotulo(nome, local) { return nome + (local ? ' (' + local + ')' : ''); }
  function fotoDe(codigo) { return BASE ? BASE + '/patches/' + codigo + '.png' : ''; }
  function ehPaginaCarrinho() { return !!document.getElementById('main-cart-items'); }
  function jsonPost(url, corpo) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(corpo) });
  }
  function fnv(txt, semente) {
    var h = semente >>> 0;
    for (var i = 0; i < txt.length; i++) { h ^= txt.charCodeAt(i); h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0; }
    return h >>> 0;
  }
  function amarra(txt) { return 't' + fnv(txt, 2166136261).toString(36) + '-' + fnv(txt, 16777619).toString(36); }
  function codigosDe(lista) {
    var out = [];
    if (!lista) return out;
    String(lista).split(',').forEach(function (p) { var partes = p.split('@'); var c = (partes[0] || '').trim(); if (c) out.push({ codigo: c, local: (partes[1] || '').trim() }); });
    return out;
  }
  function ehLinhaExtra(it) {
    if (!it) return false;
    if (it.properties && it.properties._md_addon === '1') return true;
    if (HANDLE && it.handle === HANDLE) return true;
    return false;
  }

  /* ---------- interceptacao do add to cart ---------- */
  function escolhidos(f) {
    var vistos = [];
    function juntar(lista) { Array.prototype.forEach.call(lista, function (el) { if (vistos.indexOf(el) === -1) vistos.push(el); }); }
    juntar(f.querySelectorAll('input[data-md-patch-codigo]:checked'));
    var idDoForm = f.getAttribute('id');
    if (idDoForm) {
      var idSeguro = String(idDoForm).replace(/["\\\]]/g, '');
      juntar(document.querySelectorAll('[data-md-patches-form="' + idSeguro + '"] input[data-md-patch-codigo]:checked'));
    }
    var lista = [];
    vistos.forEach(function (el) {
      var codigo = (el.getAttribute('data-md-patch-codigo') || '').trim();
      var local = (el.getAttribute('data-md-patch-local') || '').trim();
      var nome = (el.getAttribute('data-md-patch-nome') || '').trim();
      if (!nome) { var item = el.closest && el.closest('.md-patches__item'); var no = item && item.querySelector('.md-patches__nome'); nome = no ? (no.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
      if (!nome) nome = nomeDe(codigo);
      if (codigo) lista.push({ codigo: codigo, local: local, nome: nome });
    });
    lista.sort(function (a, b) {
      var ia = LOCAIS.indexOf(a.local), ib = LOCAIS.indexOf(b.local);
      if (ia < 0) ia = 99; if (ib < 0) ib = 99;
      if (ia !== ib) return ia - ib;
      if (a.local !== b.local) return a.local < b.local ? -1 : 1;
      if (a.codigo === b.codigo) return 0;
      return a.codigo < b.codigo ? -1 : 1;
    });
    return lista;
  }
  /* "Home 26/27 Men's Shirt - L / Customize": titulo do produto (data-md-patches-produto no fieldset) + variante escolhida */
  function tituloCamisa(f) {
    var produto = '', variante = '';
    try {
      var idDoForm = f.getAttribute('id'), fs = null;
      if (idDoForm) fs = document.querySelector('[data-md-patches-form="' + String(idDoForm).replace(/["\\\]]/g, '') + '"]');
      if (!fs) fs = f.querySelector('[data-md-patches-produto]') || document.querySelector('[data-md-patches-produto]');
      produto = (fs && fs.getAttribute('data-md-patches-produto')) || '';
      if (!produto) { var h1 = document.querySelector('.product__title h1, h1.product__title, .product__info-container h1, h1'); produto = h1 ? (h1.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
      var idVar = (f.querySelector('[name="id"]') || {}).value;
      var sel = document.querySelector('script[data-selected-variant]');
      if (sel) { var v = JSON.parse(sel.textContent || 'null'); if (v && String(v.id) === String(idVar) && v.title && v.title !== 'Default Title') variante = v.title; }
      if (!variante) {
        var opts = [];
        Array.prototype.forEach.call(document.querySelectorAll('variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked, variant-selects select'), function (el) { if (el.value) opts.push(el.value); });
        variante = opts.join(' / ');
      }
    } catch (e) {}
    return produto + (variante ? ' - ' + variante : '');
  }
  function secoesDoDrawer(drawer) {
    try { if (drawer && typeof drawer.getSectionsToRender === 'function') return drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','); } catch (e) {}
    return 'cart-drawer,cart-icon-bubble';
  }
  function eventoLinhas(f, linhas) {
    var SE = window.StandardEvents || {};
    if (!SE.CartLinesUpdateEvent) return null;
    try {
      var adiado = SE.CartLinesUpdateEvent.createPromise();
      var alvo = (f.closest && f.closest('product-form')) || f;
      alvo.dispatchEvent(new SE.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: linhas, promise: adiado.promise }));
      return adiado;
    } catch (e) { return null; }
  }
  function resolverEventoLinhas(adiado) {
    if (!adiado) return;
    var SE = window.StandardEvents || {};
    if (!SE.CartLinesUpdateEvent) return;
    fetch(URL_CART + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || !c.currency) throw new Error('cart sem currency');
      adiado.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(c) });
    }).catch(function (e) { try { adiado.reject(e); } catch (e2) {} });
  }
  /* agrupa os patches por variante de cobranca: [{ id, quantity, properties }] */
  function extrasDe(patches, qtd, tie, camisaTxt) {
    var porVar = {}, lista = [];
    patches.forEach(function (p) {
      var vid = varDe(p.codigo);
      if (!porVar[vid]) { porVar[vid] = { id: vid, quantity: 0, nomes: [], properties: { _md_tie: tie, _md_addon: '1' } }; lista.push(porVar[vid]); }
      porVar[vid].quantity += qtd;
      porVar[vid].nomes.push(rotulo(p.nome || nomeDe(p.codigo), p.local));
    });
    lista.forEach(function (e) { e.properties['Patch'] = e.nomes.join(', '); if (camisaTxt) e.properties['Shirt'] = camisaTxt; delete e.nomes; });
    return lista;
  }

  async function adicionarComPatches(f, patches) {
    var botao = f.querySelector('[name="add"], [type="submit"]');
    var girador = f.querySelector('.loading__spinner');
    if (botao) { botao.setAttribute('aria-disabled', 'true'); botao.classList.add('loading'); }
    if (girador) girador.classList.remove('hidden');
    var adiado = null, adicionou = false;
    try {
      var fd = new FormData(f);
      var qtd = parseInt(fd.get('quantity'), 10) || 1;
      var idCamisa = fd.get('id');
      if (!idCamisa) throw new Error('form sem id de variante');
      var props = {}, chaves = [];
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) { props[m[1]] = v; chaves.push(m[1]); } });
      chaves.sort();
      var propsOrdenadas = chaves.map(function (k) { return k + '=' + props[k]; }).join(';');
      var plano = fd.get('selling_plan') || '';
      var codigos = patches.map(function (p) { return p.codigo + '@' + p.local; }).join(',');
      var tie = amarra(String(idCamisa) + '|' + codigos + '|' + propsOrdenadas + '|' + plano);
      props['Patches'] = patches.map(function (p) { return rotulo(p.nome || nomeDe(p.codigo), p.local); }).join(', ');
      var fotos = patches.map(function (p) { return fotoDe(p.codigo); }).filter(Boolean).join(' , ');
      if (fotos) props['Patch photo'] = fotos;
      props['_md_patches'] = codigos;
      props['_md_tie'] = tie;
      var camisa = { id: idCamisa, quantity: qtd, properties: props };
      if (plano) camisa.selling_plan = plano;
      var extras = extrasDe(patches, qtd, tie, tituloCamisa(f));
      /* extras primeiro no array: o /cart/add lista na ordem inversa, entao a camisa aparece antes dos extras */
      var corpo = { items: extras.concat([camisa]) };
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        corpo.sections = secoesDoDrawer(drawer);
        corpo.sections_url = window.location.pathname;
        if (typeof drawer.setActiveElement === 'function') { try { drawer.setActiveElement(document.activeElement); } catch (e) {} }
      }
      adiado = eventoLinhas(f, [{ merchandiseId: idCamisa, quantity: qtd }].concat(extras.map(function (e) { return { merchandiseId: String(e.id), quantity: e.quantity }; })));
      var res = await jsonPost(URL_ADD, corpo);
      if (!res.ok) throw new Error('cart/add ' + res.status);
      adicionou = true;
      var resp = await res.json();
      if (resp && resp.status) throw new Error(resp.description || resp.message || 'cart/add');
      resolverEventoLinhas(adiado); adiado = null;
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'md-patches', productVariantId: idCamisa, cartData: resp }); } catch (e) {}
      }
      if (drawer && resp.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(resp); }
      else window.location.href = URL_CART;
    } catch (e) {
      if (adiado && adiado.reject) { try { adiado.reject(e); } catch (e2) {} }
      if (!adicionou) { try { f.submit(); } catch (e3) {} }
      else window.location.href = URL_CART;
    } finally {
      if (botao) { botao.removeAttribute('aria-disabled'); botao.classList.remove('loading'); }
      if (girador) girador.classList.add('hidden');
    }
  }

  if (VARIANTE) {
    document.addEventListener('submit', function (ev) {
      var f = ev.target, patches;
      try {
        if (!f || !f.getAttribute) return;
        var acao = f.getAttribute('action') || '';
        if (acao.indexOf('/cart/add') === -1) return;
        var campoId = f.querySelector('[name="id"]');
        if (!campoId || !campoId.value) return;
        if (String(campoId.value) === String(VARIANTE)) return;
        patches = escolhidos(f);
        if (!patches.length) return;
      } catch (e) { return; }
      ev.preventDefault();
      ev.stopImmediatePropagation();
      adicionarComPatches(f, patches);
    }, true);
  }

  /* ---------- reconciliacao ---------- */
  function repintarPagina(resp) {
    var itens = document.getElementById('main-cart-items'), rodape = document.getElementById('main-cart-footer'), alvos = [];
    if (itens) alvos.push({ id: 'main-cart-items', secao: itens.dataset.id, seletor: '.js-contents' });
    if (rodape) alvos.push({ id: 'main-cart-footer', secao: rodape.dataset.id, seletor: '.js-contents' });
    alvos.push({ id: 'cart-icon-bubble', secao: 'cart-icon-bubble', seletor: '.shopify-section' });
    alvos.forEach(function (a) {
      var html = resp.sections && resp.sections[a.secao], no = document.getElementById(a.id);
      if (!html || !no) return;
      var destino = no.querySelector(a.seletor) || no;
      var origem = new DOMParser().parseFromString(html, 'text/html').querySelector(a.seletor);
      if (origem) destino.innerHTML = origem.innerHTML;
    });
    var vazio = resp.item_count === 0, lista = document.querySelector('cart-items');
    if (lista) lista.classList.toggle('is-empty', vazio);
    if (rodape) rodape.classList.toggle('is-empty', vazio);
  }
  function repintar(resp) {
    try {
      if (ehPaginaCarrinho()) { repintarPagina(resp); return; }
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || !resp || !resp.sections) return;
      if (drawer.classList.contains('active') && typeof drawer.renderContents === 'function') {
        if (resp.item_count === 0) drawer.classList.add('is-empty');
        drawer.renderContents(resp);
      } else {
        var dentroGaveta = document.getElementById('CartDrawer');
        var novaGaveta = resp.sections['cart-drawer'] ? new DOMParser().parseFromString(resp.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer') : null;
        if (dentroGaveta && novaGaveta) {
          dentroGaveta.innerHTML = novaGaveta.innerHTML;
          var overlay = document.getElementById('CartDrawer-Overlay');
          if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
        }
        var bolha = document.getElementById('cart-icon-bubble');
        if (bolha && resp.sections['cart-icon-bubble']) {
          var tmp = document.createElement('div'); tmp.innerHTML = resp.sections['cart-icon-bubble'];
          var dentro = tmp.querySelector('.shopify-section') || tmp; bolha.innerHTML = dentro.innerHTML;
        }
        if (resp.item_count === 0) drawer.classList.add('is-empty'); else drawer.classList.remove('is-empty');
      }
    } catch (e) {}
  }
  async function reconciliar() {
    if (ocupado) { pendente = true; return; }
    ocupado = true;
    try {
      var carrinho = await (await fetch(URL_CART + '.js', { headers: { Accept: 'application/json' } })).json();
      var itens = (carrinho && carrinho.items) || [], grupos = {}, updates = {}, mudou = false;
      itens.forEach(function (it) {
        var tie = it.properties && it.properties._md_tie;
        if (!tie) return;
        if (!grupos[tie]) grupos[tie] = { alvo: {}, nomes: {}, camisa: '', extras: [] };
        var g = grupos[tie];
        if (ehLinhaExtra(it)) { g.extras.push(it); return; }
        codigosDe(it.properties._md_patches).forEach(function (c) {
          var vid = varDe(c.codigo);
          g.alvo[vid] = (g.alvo[vid] || 0) + it.quantity;
          if (!g.nomes[vid]) g.nomes[vid] = [];
          var r = rotulo(nomeDe(c.codigo), c.local); if (g.nomes[vid].indexOf(r) === -1) g.nomes[vid].push(r);
        });
        if (!g.camisa) g.camisa = (it.product_title || '') + (it.variant_title && it.variant_title !== 'Default Title' ? ' - ' + it.variant_title : '');
      });
      var faltando = [];
      Object.keys(grupos).forEach(function (tie) {
        var g = grupos[tie], porVar = {};
        g.extras.forEach(function (e) { var k = String(e.variant_id); if (!porVar[k]) porVar[k] = []; porVar[k].push(e); });
        Object.keys(g.alvo).forEach(function (vid) {
          var alvo = g.alvo[vid], lista = porVar[String(vid)] || [], total = 0;
          lista.forEach(function (e) { total += e.quantity; });
          if (total === alvo) return;
          if (!lista.length) { if (alvo > 0) faltando.push({ tie: tie, id: parseInt(vid, 10), qtd: alvo, nomes: g.nomes[vid] || [], camisa: g.camisa }); return; }
          lista.forEach(function (e, i) { var nova = i === 0 ? alvo : 0; if (nova !== e.quantity) { updates[e.key] = nova; mudou = true; } });
        });
        Object.keys(porVar).forEach(function (vid) { if (g.alvo[vid]) return; porVar[vid].forEach(function (e) { if (e.quantity !== 0) { updates[e.key] = 0; mudou = true; } }); });
      });
      itens.forEach(function (it) { if (!ehLinhaExtra(it)) return; var tie = it.properties && it.properties._md_tie; if (!tie) { updates[it.key] = 0; mudou = true; } });
      var addOk = false;
      for (var i = 0; i < faltando.length; i++) {
        var falta = faltando[i], chave = falta.tie + '|' + falta.id;
        tentativasAdd[chave] = (tentativasAdd[chave] || 0) + 1;
        if (tentativasAdd[chave] > MAX_ADD) continue;
        try {
          var pp = { _md_tie: falta.tie, _md_addon: '1' };
          if (falta.nomes.length) pp['Patch'] = falta.nomes.join(', ');
          if (falta.camisa) pp['Shirt'] = falta.camisa;
          var resAdd = await jsonPost(URL_ADD, { items: [{ id: falta.id, quantity: falta.qtd, properties: pp }] });
          if (resAdd && resAdd.ok) addOk = true;
        } catch (e) {}
      }
      if (!mudou) { if (addOk) { pendente = false; setTimeout(reconciliar, 0); } return; }
      var corpo = { updates: updates };
      if (ehPaginaCarrinho()) {
        var secoes = [], noItens = document.getElementById('main-cart-items'), noRodape = document.getElementById('main-cart-footer');
        if (noItens) secoes.push(noItens.dataset.id);
        if (noRodape) secoes.push(noRodape.dataset.id);
        secoes.push('cart-icon-bubble');
        corpo.sections = secoes.join(','); corpo.sections_url = window.location.pathname;
      } else if (document.querySelector('cart-drawer')) {
        corpo.sections = secoesDoDrawer(document.querySelector('cart-drawer')); corpo.sections_url = window.location.pathname;
      }
      var res = await jsonPost(URL_UPDATE, corpo);
      if (!res.ok) return;
      var resp = await res.json();
      var gavetaFechada = document.querySelector('cart-drawer');
      if (gavetaFechada && gavetaFechada.classList.contains('active')) gavetaFechada = null;
      if (!ehPaginaCarrinho() && gavetaFechada && (!resp.sections || !resp.sections['cart-drawer'])) {
        try {
          var resSec = await fetch(URL_CART + '?section_id=cart-drawer', { headers: { Accept: 'text/html' } });
          if (resSec.ok) { var htmlSec = await resSec.text(); if (htmlSec) { if (!resp.sections) resp.sections = {}; resp.sections['cart-drawer'] = htmlSec; } }
        } catch (e) {}
      }
      repintar(resp);
    } catch (e) {
    } finally {
      ocupado = false;
      if (pendente) { pendente = false; reconciliar(); }
    }
  }
  function instalarGatilhos() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (dados) { if (dados && dados.source === 'md-patches') return; setTimeout(reconciliar, 60); });
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var estava = drawer.classList.contains('active');
      new MutationObserver(function () { var agora = drawer.classList.contains('active'); if (agora && !estava) reconciliar(); estava = agora; }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      /* Rede de seguranca: se o cart.js do Dawn repinta a gaveta mas nao chega a publicar cartUpdate
         (ele lanca excecao quando a unica linha restante e a de cobranca), a mudanca no DOM dispara
         a reconciliacao mesmo assim. Debounce de 400 ms; a propria repintura da reconciliacao gera
         no maximo uma passada extra, que nao encontra nada para mudar. */
      var tDom = 0;
      new MutationObserver(function () { clearTimeout(tDom); tDom = setTimeout(reconciliar, 400); }).observe(drawer, { childList: true, subtree: true });
    }
    if (CHECAR_NA_CARGA) reconciliar();
  }
  /* Este arquivo e carregado com defer ANTES do pubsub.js do Dawn: na hora em que roda, `subscribe`
     ainda nao existe e o DOMContentLoaded ainda nao disparou de verdade (readyState = interactive).
     Por isso os gatilhos so sao instalados no load, quando todos os scripts defer ja executaram. */
  if (document.readyState === 'complete') instalarGatilhos(); else window.addEventListener('load', instalarGatilhos);
})();
